export const TEXTS = {
  MORE_BUTTON_TEXT: (count: number) => `Ещё ${count}`,
  HIDE_BUTTON_TEXT: 'Свернуть',
  VIDEO_STREAM: 'Видеоволна',
  POINTS_GROUP: 'Группа адресов',
  EMPTY: 'Отсутствует',
};
